import React, { PureComponent } from 'react';
import {
  map
} from 'lodash';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import './CombinationsModal.scss';

class CombinationsModal extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false
    };
  }

  openClose = (event) => {
    event.preventDefault();
    this.setState({
      isOpen: !this.state.isOpen
    });

  }

  renderTable(permutations){
    return (
      <tbody>
        {
          map(permutations.permutations, (permutation, index) => {
            return (
              <tr key={ index }>
                <td>
                  { permutation.join() }
                </td>
                <td>
                  { permutations.singleStake/100 }
                </td>
                <td>
                  { permutations.odds }
                </td>
                <td>
                  { permutations.minimumProfit/100 }
                </td>
              </tr>
            );
          })
        }
      </tbody>

    );
  }

  render() {
    const { t, numbersPermutations }  = this.props;
    return (

      <div className="number-picker__modal">
        <div className="number-picker__modal-content">
          <table className="table">
            <thead className="table__header">
              <tr>
                <th>{ t('numbers.selections') }</th>
                <th>{ t('numbers.stakes') }</th>
                <th>{ t('numbers.odds') }</th>
                <th>{ t('numbers.potentialReturn') }</th>
              </tr>
            </thead>
            { this.renderTable(numbersPermutations) }
          </table>
        </div>
      </div>
    );
  }

}

CombinationsModal.propTypes = {
  nextDraws: PropTypes.object,
  t: PropTypes.func,
  numbersPermutations: PropTypes.object
};
const mapDispatch = dispatch => ({
  permutations: (obj) => dispatch.events.permutations(obj)

});

const mapState = state => ({
  numbersPermutations: state.events.numbersPermutations
});

export default connect(mapState, mapDispatch)(withTranslation('common')(CombinationsModal));
